/**
 * デビュー年から芸歴（年数）を計算する
 * @param {number} debutYear
 * @returns {number}
 */
export const getCareerYear = (debutYear) => {
  const currentYear = new Date().getFullYear();
  return currentYear - debutYear;
};
